// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "2c64d6ac" + "." + "6a704ec8f0c51cff" + ".js";
};